var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinterlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60228 0.397552H18.1372C18.7716 0.397552 19.2907 0.916622 19.2907 1.55104V3.85802C19.2907 4.49244 18.7716 5.01151 18.1372 5.01151H6.60228C5.96786 5.01151 5.44879 4.49244 5.44879 3.85802V1.55104C5.44879 0.916622 5.96786 0.397552 6.60228 0.397552ZM4.2953 6.16499H20.4441C22.3589 6.16499 23.9046 7.71067 23.9046 9.62546V14.2394C23.9046 15.5083 22.8665 16.5464 21.5976 16.5464H19.2907V18.8534C19.2907 20.1222 18.2525 21.1603 16.9837 21.1603H7.75577C6.48693 21.1603 5.44879 20.1222 5.44879 18.8534V16.5464H3.14182C1.87298 16.5464 0.834839 15.5083 0.834839 14.2394V9.62546C0.834839 7.71067 2.38051 6.16499 4.2953 6.16499ZM8.90926 18.8534H15.8302C16.4646 18.8534 16.9837 18.3343 16.9837 17.6999V13.0859H7.75577V17.6999C7.75577 18.3343 8.27484 18.8534 8.90926 18.8534ZM20.4441 10.7789C19.8097 10.7789 19.2907 10.2599 19.2907 9.62546C19.2907 8.99104 19.8097 8.47197 20.4441 8.47197C21.0786 8.47197 21.5976 8.99104 21.5976 9.62546C21.5976 10.2599 21.0786 10.7789 20.4441 10.7789Z",
    fill: "#0081FE",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterlogo);
export default __webpack_public_path__ + "static/media/printerlogo.0fe898bc40bfc7a79f527c474e976c51.svg";
export { ForwardRef as ReactComponent };